import React from 'react';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
import { Link as ScrollLink } from 'react-scroll';

import env from 'Env';
import StarRating from 'Components/ProductReviews/UserReviews/StarRating';
import 'Components/Product/CriticReviews/MobileReviewHeader.scss';

const MobileReviewHeader = ({ product }) => {
  const userReviewRatingScore = _get(product, 'userReviewSummary.rating_score');
  const userReviewTotalRatings = _get(product, 'userReviewSummary.total_ratings');

  const recommendedThreshold = env.percentRecommendedThreshold;
  let reviewScore = 0;
  let enoughCriticReviews = false;

  let reviewImgLink = 'https://cdn.fanatical.com/production/brand/metacritic/svg/metacritic-icon.svg';
  let reviewImgAlt = 'Metacritic';

  if (product.metaCritic && _get(product, 'metaCritic.score') >= recommendedThreshold) {
    reviewScore = _get(product, 'metaCritic.score', 0);
    enoughCriticReviews = _get(product, 'metaCritic.reviews.length', 0) >= 3;
  } else if (product.openCritic && _get(product, 'openCritic.score') >= recommendedThreshold) {
    reviewImgLink = 'https://cdn.fanatical.com/production/brand/opencritic/svg/opencritic-icon.svg';
    reviewImgAlt = 'OpenCritic';

    reviewScore = _get(product, 'openCritic.score', 0);
    enoughCriticReviews = _get(product, 'openCritic.reviews.length', 0) >= 3;
  }

  const showCriticScore = reviewScore >= recommendedThreshold;

  if ((product.preorder && !showCriticScore)) {
    return false;
  }

  if (!showCriticScore && !userReviewRatingScore) {
    return false;
  }


  const CriticTag = enoughCriticReviews ? ScrollLink : 'div';

  return (
    <section className="MobileReviewHeader">
      {!product.preorder && userReviewRatingScore &&
      <ScrollLink
        spy
        smooth
        activeClass="active"
        to="user-reviews"
        duration={500}
        className="MobileReviewHeader__userReviewContainer"
      >
        <div className="MobileReviewHeader__userReviewContainer__stars mr-2">
          <StarRating rating={userReviewRatingScore} />
        </div>

        <div className="MobileReviewHeader__userReviewContainer__score mr-1">
          {userReviewRatingScore}
        </div>
        <div className="MobileReviewHeader__userReviewContainer__ratings">
          ({userReviewTotalRatings})
        </div>
      </ScrollLink>
      }

      {showCriticScore &&
        <CriticTag
          spy
          smooth
          activeClass="active"
          to="critic-reviews"
          duration={500}
          offset={-80}
          className="MobileReviewHeader__criticContainer"
        >
          <div className="MobileReviewHeader__criticContainer__score">
            {reviewScore}
          </div>
          <div className="MobileReviewHeader__criticContainer__logo">
            <img
              src={reviewImgLink}
              width="100px"
              alt={reviewImgAlt}
            />
          </div>
        </CriticTag>

      }
    </section>
  );
};

MobileReviewHeader.propTypes = {
  product: PropTypes.shape({}).isRequired,
};

export default MobileReviewHeader;
